import React, { useState, useRef, useEffect }  from 'react';
import { RedrawForm, RedrawOnAllOptionChangesComplete } from 'components/show_drawing/redraw_form/index.js';
import { GetRequest } from 'components/common/index.js';
import DrawingSvg from 'components/show_drawing/DrawingSvg.jsx';
import DebugPanel from 'components/show_drawing/DebugPanel.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import DownloadButtonsSection from 'components/show_drawing_download_section/DownloadButtonsSection';
import Constants from 'components/show_drawing/Constants.jsx';
import DrawingFooter from 'components/show_drawing/DrawingFooter.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'
import EventCacheService from 'components/common/EventCacheService.js'
import catalogNamePathChanged from 'components/show_drawing/catalogNamePathChanged.js';

const ShowDrawing = ( {initialId, initialUnit, initialTheme, environment, demo, advancedOptionsHidden, initialUserDownloadId, initialOptions, technicalPropertiesEnabled, materialGroupChooserEnabled, partMaterialsEnabled, comboEnabled, initialActiveCombosByGuestName, isAdmin, canUseMeasureTool, loggedIn} ) => {
  const debugFlag = false;
  const debug = environment == 'development' && debugFlag
  const [debugEntry, setDebugEntries] = useState([])
  const [id, setId] = useState(initialId);
  const [userDowloadId, setUserDowloadId] = useState(initialUserDownloadId);
  const [idToReset, setIdToReset] = useState(0);
  const [idForSvg, setIdForSvg] = useState(initialId);

  const [unit, setUnit] = useState(initialUnit);
  const [drawing, setDrawing] = useState( { id: initialId, main_group_chooser: {} } )
  const [drawingForSvg, setDrawingForSvg] = useState( { id: initialId, main_group_chooser: {} } )

  const [theme, setTheme] = useState( initialTheme )
  const [dimensionTextschecked, setDimensionTextschecked] = useState(true);
  const [boundingBoxDimensionTextsIncluded, setBoundingBoxDimensionTextsIncluded] = useState(true);

  const [redrawRequested, setRedrawRequested] = useState(false);
  const [redrawInProgress, setRedrawInProgress] = useState(false);
  const [downloadsDisabled, setDownloadsDisabled] = useState(false);

  const [currentDrawingOptions, setCurrentDrawingOptions] = useState({})
  const [currentUserDrawingOptions, setCurrentUserDrawingOptions] = useState({})
  const [proposedDrawingOptions, setProposedDrawingOptions] = useState({})

  const [addOns, setAddons] = useState([])
  const [addOnOptions, setAddOnOptions] = useState({})
  const [addOnsChanged, setAddOnsChanged] = useState(false)

  const [combos, setCombos] = useState([])
  const [activeCombosByGuestName, setActiveCombosByGuestName] = useState(initialActiveCombosByGuestName)

  const [resetEnabled, setResetEnabled] = useState(false)

  const formRef = useRef();
  const optionsColRef = useRef();

  const [optionsUserChanged, setOptionsUserChanged] = useState([]);
  const addToOptionsUserChanged = (option) => {
    setOptionsUserChanged( (prev) => prev.concat(option.name).filter(onlyUnique) )
  }

  const removeFromOptionsUserChanged = (option) => {
    setOptionsUserChanged( (prev) => prev.filter(item => item != option.name).filter(onlyUnique) )
  }

  const [advancedOptionsVisible, setAdvancedOptionsVisible] = useState(false);

  const getDrawing = () => {
    // https://diecuttemplates.com.dev/drawing-data/72606
    if(id == null) { return }

    GetRequest({
      url: `/drawing-data/${id}/${window.locale}`,
      callback: (data) => {
        setDrawing( () => data.drawing)
        setCombos( () => data.combos || [])
        window.drawing_id = id;
        emitEvent('window.drawing_id_changed',{ id: id })
        window.loggedIn = data.user.logged_in;
        setCurrentUserDrawingOptions( () => data.drawing.default_options_in_unit)
        const catalogNamePath = catalogNamePathRef.current;
        if(catalogNamePath != undefined && catalogNamePath.id == id) {
          showCatalogName(catalogNamePath);
        } else {
          $("#header_breadcrumbs").html(data.drawing.breadcrumbs);
        }
        if(window.loggedIn) {
          getDrawingNote()
        }

        if($("#show_in_admin_a").length > 0) {
          $("#show_in_admin_a").attr("href", `/drawings/${id}/points`)
        }
      }
    })
  }

  // { id, catalog_name, path, page_title, breadcrumbs } of the last redraw's
  // combination, under its catalog name (/dielines/186635/cartons-becf-21d0b-f), so
  // changing a technical property shows the customer the catalog name they
  // switched to, as if it were another drawing.
  const catalogNamePathRef = useRef();

  const onCatalogNamePath = (drawingId, redrawn) => {
    if(demo || redrawn.path == undefined || drawingId != drawing.id) { return }

    const previous = catalogNamePathRef.current;
    catalogNamePathRef.current = { id: drawingId, catalog_name: redrawn.catalog_name, path: redrawn.path, page_title: redrawn.page_title, breadcrumbs: redrawn.breadcrumbs };
    showCatalogName(catalogNamePathRef.current);
    if(!catalogNamePathChanged(previous, catalogNamePathRef.current, initialOptions != undefined)) { return }

    window.history.replaceState({}, redrawn.page_title, pathAndDownloadId());
  }

  // The heading, its copy button and the tab title name the combination drawn,
  // even while a page opened with options of its own keeps its url.
  const showCatalogName = (catalogNamePath) => {
    $("#header_breadcrumbs").text(catalogNamePath.breadcrumbs);
    $("#description_breadcrumbs").text(catalogNamePath.breadcrumbs);
    $(".js-copy-catalog-name[data-copy-source='dielines_header']").attr('data-catalog-name', catalogNamePath.catalog_name);
    document.title = catalogNamePath.page_title;
    emitEvent('drawing.catalog_name_changed', { id: catalogNamePath.id, catalog_name: catalogNamePath.catalog_name });
  }

  const onDrawingChange = () => {
    if(!demo && initialOptions ==undefined) {
      window.history.pushState( {} , drawing.page_title, pathAndDownloadId() );
    }

    if(drawing.layouts_landing_path != undefined && $("#menu_tab_nesting").length > 0) {
      $("#menu_tab_nesting").attr("data-action", drawing.layouts_landing_path)
    }

    if(drawing.three_d_path != undefined && $("#menu_tab_3d").length > 0) {
      $("#menu_tab_3d").attr("data-action", drawing.three_d_path)
    }

    if(drawing.dielines_api_tab_path != undefined && $("#menu_tab_dielines_api").length > 0) {
      $("#menu_tab_dielines_api").attr("data-action", drawing.dielines_api_tab_path)
    }
  }

  const onRecoverySwapOptionsMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule
    const first = formRef.current.querySelector(`input[name="${rule.recovery_swap_options[0]}"]`);
    const second = formRef.current.querySelector(`input[name="${rule.recovery_swap_options[1]}"]`);

    const values = {}
    values[rule.recovery_swap_options[0]] = second.value
    values[rule.recovery_swap_options[1]] = first.value

    emitEvent(Constants.drawing_set_values_and_redraw, { id: id, names: rule.recovery_swap_options, values: values })
  }

  const onRecoverySwapOptionsHighlightMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule
    emitEvent(Constants.drawing_option_highlight, { id: id, name: rule.recovery_swap_options[0], value: true} )
    emitEvent(Constants.drawing_option_highlight, { id: id, name: rule.recovery_swap_options[1], value: true} )
  }

  // msg.detail.drawingId is set by ComboBrokenRulesBanner so the event reaches
  // the per-guest OptionsCommon (registered with id=guest_drawing.id) for
  // 'ask' transformations. Host rules and 'same'-transformation guests leave
  // it unset and fall through to the main drawing id.
  const onRecoverySetValueMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule
    // A rule can offer several apply_to solutions; msg.detail.recovery is the
    // one whose button was clicked (fall back to the first for older callers).
    const recovery = msg.detail.recovery || (rule.recovery_apply_to && rule.recovery_apply_to[0])
    if(!recovery) { return; }

    emitEvent(Constants.drawing_option_set_value, {
      id: msg.detail.drawingId || id,
      name: recovery.name,
      value: recovery.value,
      redraw: true
    })
  }

  const onRecoverySetRecommendedValueMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule

    emitEvent(Constants.drawing_option_set_value, {
      id: msg.detail.drawingId || id,
      name: rule.recovery_recommended_value.name,
      value: rule.recovery_recommended_value.value,
      redraw: true
    })
  }

  const onRecoverySerValueHighlightMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule;
    (rule.recovery_apply_to || []).forEach((recovery) => {
      emitEvent(Constants.drawing_option_highlight, { id: id, name: recovery.name, value: true} )
    })
  }

  const onAdvancedOptionSetVisibleMsgReceived = useRef();
  const onAdvancedOptionSetVisibleMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    setAdvancedOptionsVisible( () => msg.detail.value )
    onAdvancedOptionSetVisibleMsgReceived.current = true;
  }

  const onAddAddOnMsg = (msg) => {
    if(msg.detail.id != id) { return }

    for (const [addOnId, options] of Object.entries(msg.detail.options)) {
      var optionNames = Object.keys(options)
      for(let i = 0; i< optionNames.length; i++) {
        addToOptionsUserChanged( {name: optionNames[i]} )
      }
      addAddOnToDieline( addOnId, options);
    }

  }

  const addAddOnToDieline = (id, options) => {
    setAddons( (prev) =>  Array.from(new Set( prev.concat( parseInt(id) ) )) )
    setAddOnOptions( (prev) => {
      prev[id] = options;
      return { ...prev }
    } )
    setAddOnsChanged( () => true )
  }

  const removeAddOnFromDieline = (id) => {
    setAddons ( (prev) => prev.filter(_id => parseInt(_id) != parseInt(id)) )
    setAddOnsChanged( () => true )
    setRedrawRequested( () => true )
  }

  const addOnsAsQueryStr = () => {
    var query = "";
    for(var i = 0; i< addOns.length; i++) {
      query = query + '&add_ons[]=' + addOns[i];
      for (const [key, value] of Object.entries( addOnOptions[ addOns[i] ] )) {
        query = `${query}&${key}=${value}`
      }
    }
    return query;
  }

  const GetRequestPath = () => {
    const formDataJSON = {
      options_user_changed: optionsUserChanged.join(','),
      dimension_texts_included: true,
      bounding_box_dimension_texts_included: boundingBoxDimensionTextsIncluded ? 1 : 0,
      advanced_options_visible: advancedOptionsVisible ? 1 : 0,
      _ts: Date.now(),
    };

    (new FormData(formRef.current)).forEach((value, key) => { formDataJSON[key] = value });
    window.GetRequestPathData = formDataJSON;

    if(formDataJSON["material_id"] == undefined && formDataJSON["malzeme"] == undefined) {
      return ''
    }

    return `${id}?${new URLSearchParams(formDataJSON).toString()}&${addOnsAsQueryStr()}`
  }

  const pathAndDownloadId = () => {
    if(drawing == undefined || drawing.path == undefined) { return '' }
    const catalogNamePath = catalogNamePathRef.current;
    let path = (catalogNamePath != undefined && catalogNamePath.id == drawing.id) ? catalogNamePath.path : drawing.path;
    if(userDowloadId != undefined && userDowloadId != '') {
      path = path + '/' + userDowloadId;
    }
    if(comboEnabled) {
      const ids = Object.values(activeCombosByGuestName);
      if(ids.length > 0) {
        path = path + '?combo_ids=' + ids.join(',');
      }
    }
    return path;
  }

  const onResetMsg = (msg) => {
    if(msg.detail.id == id) {
      setIdToReset ( () => id )
      setId( () => null )
    }
  }

  const performReset = () => {
    if(id != null) { return }
    if(idToReset == 0) { return }

    setCurrentUserDrawingOptions( () => {} )
    setAdvancedOptionsVisible( () => false )
    setCurrentDrawingOptions( () => {} )
    setId( () => idToReset );
    setAddons( () => [] )
    setActiveCombosByGuestName( () => ({}) )
    setOptionsUserChanged( () => [] )
  }

  // useEffect starts
  // Initialize EventCacheService once on mount
  useEffect(() => {
    EventCacheService.initialize();
  }, [])

  useEffect(getDrawing, [id])
  useEffect( () => {
    setIdForSvg( () => id );
    setDrawingForSvg( () => drawing );
  }, [drawing])

  useEffect( onDrawingChange, [drawing])
  useEffect(() => { setRedrawRequested( () => addOnsChanged ) }, [addOnOptions])
  useEffect(() => { setCookie("unit", unit, 365)  }, [unit])

  useEffect(() => {
    if(unit != initialUnit) {
      setUserDowloadId( () => undefined )
      emitEvent(Constants.drawing_reset_form, { id: id })
    }
  }, [unit])

  useEffect( window.get_request_path = GetRequestPath, [])
  useEffect(performReset, [id, idToReset])

  useEffect(() => {
    if (!comboEnabled) { return; }
    const url = new URL(window.location.href);
    const ids = Object.values(activeCombosByGuestName);
    if (ids.length > 0) {
      url.searchParams.set('combo_ids', ids.join(','));
    } else {
      url.searchParams.delete('combo_ids');
    }
    window.history.replaceState({}, drawing.page_title || '', url.pathname + url.search);

    // Tell sibling components (MenuTabs) about the combo state change so they
    // can re-render — they live in their own react_component root and don't
    // share React state with ShowDrawing.
    document.dispatchEvent(new CustomEvent('combo_state_changed', {
      detail: { hasGuests: ids.length > 0 }
    }));
  }, [activeCombosByGuestName, comboEnabled])

  const isFirstComboRunRef = useRef(true);
  useEffect(() => {
    if (isFirstComboRunRef.current) { isFirstComboRunRef.current = false; return; }
    if (!comboEnabled) { return; }
    setRedrawRequested(() => true);
  }, [activeCombosByGuestName, comboEnabled])

  useEffect( () => {
    emitEvent('addDebugEntry', { event: "[ShowDrawing] ID changed" , id: id })
  }, [id])

  useEffect(() => {
    if(advancedOptionsVisible && onAdvancedOptionSetVisibleMsgReceived.current) {
      emitEvent(Constants.advanced_options_set_visible_complete, { id: id } )
      onAdvancedOptionSetVisibleMsgReceived.current = false;
    }
  }, [advancedOptionsVisible])

  useEffect( () => {
    if(redrawInProgress) {
      disableMenuTabs();
    }
  },  [redrawInProgress])

  useEffect( () => {
    if(downloadsDisabled) {
      disableMenuTabs();
    } else {
      enableMenuTabs();
    }
  },[downloadsDisabled])
  useEffect( () => { if(theme != initialTheme) { setUserParam('redraw_theme', theme, () => {} ) } } , [theme])

  // useEffect ends
  MyEventListener([
    {
      key: 'addDebugEntry',
      callback: (msg) => { setDebugEntries( (prev) => prev.concat( [msg.detail] )) }
    },
    {
      key: Constants.drawing_recovery_swap_options_required,
      callback: onRecoverySwapOptionsMsg
    },{
      key: Constants.drawing_recovery_swap_options_highlight_required,
      callback: onRecoverySwapOptionsHighlightMsg
    },{
      key: Constants.drawing_recovery_set_value_required,
      callback: onRecoverySetValueMsg
    },{
      key: Constants.drawing_recovery_use_recommended_value_required,
      callback: onRecoverySetRecommendedValueMsg
    },{
      key: Constants.advanced_options_set_visible,
      callback: onAdvancedOptionSetVisibleMsg
    },{
      key: Constants.drawing_recovery_set_value_highlight_required,
      callback: onRecoverySerValueHighlightMsg,
    }, {
      key: 'user.session_started',
      callback: getDrawing
    },{
      key:  Constants.drawing_reset_form,
      callback: onResetMsg
    },{
      key:  Constants.drawing_add_add_on,
      callback: onAddAddOnMsg
    }
  ])

  if(id == null) { return }
  return (
    <div className="container">

        <div className="row">
          <div className={`col-lg-12`}>
            <div className={`col-lg-3 ${styles.optionsCol} ${redrawInProgress ? 'disabledForm' : ''}`} id="optionsCol" ref={optionsColRef}>
              {debug && <>[{id}]</>}
              <form ref={formRef}>
                <RedrawForm
                  id={id}
                  userDowloadId={userDowloadId}
                  setId={setId}
                  unit={unit}
                  setUnit={setUnit}
                  drawing={drawing}
                  theme={theme}
                  setRedrawRequested={setRedrawRequested}
                  optionsUserChanged={optionsUserChanged}
                  addToOptionsUserChanged={addToOptionsUserChanged}
                  removeFromOptionsUserChanged={removeFromOptionsUserChanged}
                  redrawInProgress={redrawInProgress}
                  debug={debug}
                  formRef={formRef}
                  GetRequestPath={GetRequestPath}
                  currentDrawingOptions={currentDrawingOptions}
                  addAddOnToDieline={addAddOnToDieline}
                  removeAddOnFromDieline={removeAddOnFromDieline}
                  addOnsAsQueryStr={addOnsAsQueryStr}
                  advancedOptionsVisible={advancedOptionsVisible}
                  setAdvancedOptionsVisible={setAdvancedOptionsVisible}
                  advancedOptionsHidden={advancedOptionsHidden}
                  resetEnabled={resetEnabled}
                  setResetEnabled={setResetEnabled}
                  dimensionTextschecked={dimensionTextschecked}
                  setDimensionTextschecked={setDimensionTextschecked}
                  isAdmin={isAdmin}
                  boundingBoxDimensionTextsIncluded={boundingBoxDimensionTextsIncluded}
                  setBoundingBoxDimensionTextsIncluded={setBoundingBoxDimensionTextsIncluded}
                  initialOptions={initialOptions}
                  technicalPropertiesEnabled={technicalPropertiesEnabled}
                  materialGroupChooserEnabled={materialGroupChooserEnabled}
                  partMaterialsEnabled={partMaterialsEnabled}
                  comboEnabled={comboEnabled}
                  combos={combos}
                  activeCombosByGuestName={activeCombosByGuestName}
                  setActiveCombosByGuestName={setActiveCombosByGuestName}
                />
                </form>
            </div>

            <div className={`col-lg-9 ${styles.svgCol}`}>
              {debug && <> <DebugPanel debugEntry={debugEntry} setDebugEntries={setDebugEntries} /> <hr /> </>}

              <DrawingSvg
                id={idForSvg}
                drawing={drawingForSvg}
                unit={unit}
                theme={theme}
                setTheme={setTheme}
                redrawRequested={redrawRequested}
                setRedrawRequested={setRedrawRequested}
                setRedrawInProgress={setRedrawInProgress}
                redrawInProgress={redrawInProgress}
                formRef={formRef}
                optionsUserChanged={optionsUserChanged}
                debug={debug}
                GetRequestPath={GetRequestPath}
                setCurrentDrawingOptions={setCurrentDrawingOptions}
                setCurrentUserDrawingOptions={setCurrentUserDrawingOptions}
                setProposedDrawingOptions={setProposedDrawingOptions}
                advancedOptionsVisible={advancedOptionsVisible}
                setResetEnabled={setResetEnabled}
                optionsColRef={optionsColRef}
                setDownloadsDisabled={setDownloadsDisabled}
                dimensionTextschecked={dimensionTextschecked}
                resetEnabled={resetEnabled}
                canUseMeasureTool={canUseMeasureTool}
                loggedIn={loggedIn}
                onCatalogNamePath={onCatalogNamePath}
              />

               <DrawingFooter
                  id={id}
                  unit={unit}
                  drawing={drawing}
                  theme={theme}
                  setTheme={setTheme}
                />

            </div>
          </div>
        </div>


        <div className="row">
          <div className={`col-lg-12`} className={`${downloadsDisabled ? 'disabledForm' : ''}`} >

            <DownloadButtonsSection
              id={id}
              drawing={drawing}
              currentDrawingOptions={currentDrawingOptions}
              advancedOptionsVisible={advancedOptionsVisible}
              dimensionTextschecked={dimensionTextschecked}
              currentUserDrawingOptions={currentUserDrawingOptions}
              redrawInProgress={redrawInProgress}
              comboEnabled={comboEnabled}
              formRef={formRef}
            />

          </div>
        </div>

      </div>

  )
}

export default ShowDrawing;
